import { duckify, filterDuck } from 'utils/duckify';

import {
  customerLedgerItems
} from '../../ducks/index';

import queryString from 'query-string';
import { compose } from 'redux';
import withPagination from 'hocs/withPagination';
import Placeholder from 'components/Placeholder';
import ContactList from 'components/ContactList/ContactList';
import React from 'react';
import {titleize, formatDate} from 'utils';
import Pagination from 'react-ultimate-pagination-bootstrap-4';
import { ContactRow } from 'components/ContactList/ContactRows';
import classNames from 'classnames';

const itemTypeDisplay = (itemType) => {
  if (itemType == 'parent_pay_fee'){
    return 'Enrollment Based Billing';
  }

  return titleize(itemType);
}

const makeCustomerLedgerRow = (props) => <ContactRow className={classNames([
  'customer-ledger-item-row',
  `customer-ledger-item-row-${props.contact.id}`,
  `customer-ledger-item-row-${props.contact.item_type}`
])} {...props}/>

const columns = [
  {
    header: 'Date',
    value: (item) => <td className={'customer-ledger-effective-date'}>
      {formatDate(item.effective_date)}
    </td>,
  },
  {
    header: 'Description',
    value: 'description',
    columnClassNames: 'customer-ledger-description'
  },
  {
    header: 'Type',
    value: (item) => <td className={'customer-ledger-item-type'}>
      {itemTypeDisplay(item.item_type)}
    </td>
  },
  {
    header: 'Payment Method',
    value: (item) => <td className={'customer-ledger-payment-method'}>
      {item.metadata.payment_method}
    </td>
  },
  {
    header: 'Amount',
    value: 'amount',
    type: 'currency',
    columnClassNames: 'customer-ledger-amount'
  },
  {
    header: 'Balance',
    value: 'balance',
    type: 'currency',
    columnClassNames: 'customer-ledger-balance'
  }
];

const CustomerLedgerItemList = ({items}) =>
  <ContactList columns={columns}
               contacts={items}
               emptyMessage='Ledger is empty'
               makeRow={makeCustomerLedgerRow}
  />;

const PaginationSection = ({items, setPage, page}) => {
  const totalPages = Math.ceil(items.total / items.perPage);

  if (totalPages <=1) {
    return null;
  }

  return <div>
    <div className='contact-list-react-pagination'>
      <div className='pagination pagination-right'>
        <Pagination
          currentPage={page}
          totalPages={totalPages}
          hideFirstAndLastPageLinks
          onChange={setPage}
        />
      </div>
    </div>
  </div>;
}

const CustomerLedger = ({allDucksReady, ...props}) =>
  <Placeholder.loading ready={allDucksReady} content={() =>
    <React.Fragment>
      <div className='contact-list-react-page-header'>
        <div className='contact-list-react-page-title'>
          <h2>
            Customer Ledger
          </h2>
        </div>
      </div>

      <PaginationSection {...props}/>

      <CustomerLedgerItemList {...props}/>
    </React.Fragment>
  }/>;

const mapDucksToProps = (props) => {
  const items = filterDuck(customerLedgerItems, {
    page: props.page || 1,
    per_page: props.perPage,
    ...queryString.parse(props.location.search)
  });

  return {
    items
  };
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch, props) => ({});

export default compose(
  withPagination,
  duckify(mapDucksToProps, mapStateToProps, mapDispatchToProps)
)(CustomerLedger);
